export default __webpack_public_path__ + "static/media/avatar.18a0f84c.png";